import React, { useState, useEffect, useCallback } from "react";
// import { useEmail } from "../UserContext";
import CartModal from "./CartModal";
import darkHorseTimberLogo from "./assets/darkhorsetimber_logo.png";
import kuwaharaLogo from "./assets/kuwahara_logo.jpg";
import metalmartLogo from "./assets/metalmart_logo.png";
import northshorewoodslogo from "./assets/northshorewoods_logo.png";
import blancohardwoodlogo from "./assets/blancohardwood_logo.png";
import boardsandbeamslogo from "./assets/boardandbeams_logo.png";
import cartercustomlogo from "./assets/carter_custom_logo.png";
import slabandsteellogo from "./assets/slabandsteellogo.jpg";
import supplyreadylogo from "./assets/Supply_Ready_logo.png";
import cindyswoodlotlogo from "./assets/Cindyswoodlotlogo.png";
import nicholasfirewoodlogo from "./assets/nicholasfirewoodlogo.png";
import woodfloorwarehouselogo from "./assets/woodloorwarehouselogo.png";
import cartIcon from "./assets/cart-icon.svg"; // Import cart icon
import { formatLeadTime, hexToRgb } from "../utils/formatters";
import { config } from "../config";
import ItemModal from './ItemModal';
import InfoModal from './InfoModal';
import { formatPhoneNumber } from "../utils/formatters";
import FilterMenu from './FilterMenu';
import QuantityInput from './QuantityInput';
import './Ecomm.css';


function Ecomm() {
  const [data, setData] = useState([]); // Initialize with empty array
  const [searchTerm, setSearchTerm] = useState("");
  const [cart, setCart] = useState([]);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [theme, setTheme] = useState({
    backgroundColor: "#FFFFFF", // Default background color
    accentColor: "#FFFFFF", // Default accent color
    headerColor: "#FFFFFF", // Default header color
    headerFontColor: "#000000", // Default header font color
    primaryFontColor: "#000000", // Add default primary font color
    ruckYellow: "#ffa400",
  });

  const [total, setTotal] = useState(0); // Initialize total state
  const [shippingMethod, setShippingMethod] = useState("deliver");
  const [deliveryOption, setDeliveryOption] = useState("");
  const [deliveryFee, setDeliveryFee] = useState(0.0);
  const [tax, setTax] = useState(0.0);
  const [deliveryDate, setDeliveryDate] = useState("");
  const [deliveryTime, setDeliveryTime] = useState("");
  const [pickupDate, setPickupDate] = useState("");
  const [pickupTime, setPickupTime] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [deliveryCity, setDeliveryCity] = useState("");
  const [deliveryState, setDeliveryState] = useState("");
  const [deliveryZip, setDeliveryZip] = useState("");
  const [contactFirstName, setContactFirstName] = useState("");
  const [contactLastName, setContactLastName] = useState("");
  const [contactBusinessName, setContactBusinessName] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [billingFirstName, setBillingFirstName] = useState("");
  const [billingLastName, setBillingLastName] = useState("");
  const [billingEmail, setBillingEmail] = useState("");
  const [billingAddress, setBillingAddress] = useState("");
  const [billingPhone, setBillingPhone] = useState("");
  const [billingCity, setBillingCity] = useState("");
  const [billingState, setBillingState] = useState("");
  const [billingZip, setBillingZip] = useState("");
  const [deliveryOptions, setDeliveryOptions] = useState([]);
  const [totalDriveTime, setTotalDriveTime] = useState(0);
  const [optionsReceived, setOptionsReceived] = useState(false);
  const [formattedDeliveryAddress, setFormattedDeliveryAddress] = useState("");
  const [routeDetails, setRouteDetails] = useState(null);
  const [discount, setDiscount] = useState(0.0);
  const [discountCode, setDiscountCode] = useState("");
  const [discountRate, setDiscountRate] = useState(0.0);
  const [discountCodeId, setDiscountCodeId] = useState(null);
  const [confirmationCode, setConfirmationCode] = useState("");
  const [orderId, setOrderId] = useState("");
  const [availableDateOptions, setAvailableDateOptions] = useState([]);

  const [storeId, setStoreId] = useState(null); // State for store ID
  const [storeData, setStoreData] = useState(null);
  const [storeSchedule, setStoreSchedule] = useState(null);

  const [showQuantityLimitModal, setShowQuantityLimitModal] = useState(false);
  const [limitedItem, setLimitedItem] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const QuantityLimitModal = () => (
    <InfoModal
      show={showQuantityLimitModal}
      onClose={() => setShowQuantityLimitModal(false)}
      title="Extended Lead Time Notice"
      theme={theme}
      buttonText="I understand"
    >
      <p>
        Ordering more than {limitedItem?.quantity} units of this item will extend the lead time by 7 days.
        <br /><br />
        Please contact us directly at <a href={`tel:${storeData?.display_phone}`} style={{ color: theme.primaryFontColor }}>
          {storeData?.display_phone ? formatPhoneNumber(storeData.display_phone) : ''}
        </a> if you need this order sooner.
      </p>
    </InfoModal>
  );

  function getComplementaryColor(hexColor) {
    const color = hexColor.startsWith("#") ? hexColor.slice(1) : hexColor;
    const r = parseInt(color.slice(0, 2), 16);
    const g = parseInt(color.slice(2, 4), 16);
    const b = parseInt(color.slice(4, 6), 16);
    const compR = 255 - r;
    const compG = 255 - g;
    const compB = 255 - b;
    const compColor = `#${compR.toString(16).padStart(2, "0")}${compG
      .toString(16)
      .padStart(2, "0")}${compB.toString(16).padStart(2, "0")}`;
    return compColor;
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const storePublicId = params.get("store_public_id");

    const fetchStoreSiteData = async () => {
      if (!storePublicId) {
        window.location.href = 'https://ruckdelivery.com'; // Replace with your desired URL
      }

      try {
        const response = await fetch(
          `${config.apiUrl}/get-store-site-data`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ store_public_id: storePublicId }),
          }
        );

        if (response.ok) {
          const storeData = await response.json();

          const ruckYellow = "#ffa400";
          const accentColor = storeData.data.accent_color || ruckYellow;
          const backgroundColor = storeData.data.background_color || "#2c2c2c";
          const headerColor = storeData.data.header_color || "#FFFFFF";
          const headerFontColor = storeData.data.header_font_color || "#000000";
          const primaryFontColor = storeData.data.primary_font_color || "#1a1a1a";

          document.documentElement.style.setProperty('--background-color', backgroundColor);
          document.documentElement.style.setProperty('--accent-color', accentColor);
          document.documentElement.style.setProperty('--accent-color-rgb', hexToRgb(accentColor));
          document.documentElement.style.setProperty('--header-color', headerColor);
          document.documentElement.style.setProperty('--header-font-color', headerFontColor);
          document.documentElement.style.setProperty('--primary-font-color', primaryFontColor);

          setTheme({
            backgroundColor: backgroundColor,
            accentColor: accentColor,
            headerColor: headerColor,
            headerFontColor: headerFontColor,
            primaryFontColor: primaryFontColor,
            ruckYellow: ruckYellow
          });
          setStoreId(storeData.data.store_id);
          setStoreData(storeData.data);
          setStoreSchedule(storeData.schedule);

          if (!storeData.data.has_delivery) {
            setShippingMethod("pickup");
          }

          // Dynamically update the document title
          document.title = storeData.data.display_name
            ? `Shop - ${storeData.data.display_name}`
            : "Shop any vendor via Ruck";


            const urlParams = new URLSearchParams(window.location.search);
            const storeId = urlParams.get('store_public_id');
            // const fullPath = window.location.pathname + window.location.search;
        
            if (storeId) {
              // Also send the custom pageview event we set up
              if (window.sendGAPageView) {
                window.sendGAPageView(
                  document.title,
                  window.location.pathname,
                  window.location.search
                );
              }
            }

        } else {
          console.error("Failed to fetch store site data.");
        }
      } catch (error) {
        console.error("Error fetching store site data:", error);
      }
    };

    fetchStoreSiteData();
  }, []); // theme.ruckYellow is only used as a fallback default value

  const fetchInventory = useCallback(async () => {
    if (!storeId) return;
    try {
      const response = await fetch(
        `${config.apiUrl}/get-store-inventory`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ store_id: storeId }),
        }
      );
      if (response.ok) {
        const inventoryData = await response.json();
        console.log("inventory data:", inventoryData)
        // console.log(inventoryData);
        setData(inventoryData.data || []);
      } else {
        console.error("Failed to fetch inventory.");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching inventory:", error);
      setData([]);
    }
  }, [storeId]);
  
  useEffect(() => {
    fetchInventory();
  }, [storeId, fetchInventory]);

  useEffect(() => {
    // Calculate initial total when cart updates
    const newTotal = cart.reduce(
      (sum, item) => sum + item.retail_price * item.quantity,
      0
    );
    setTotal(newTotal);
  }, [cart]);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  // Get unique categories and their subcategories from active items only
  const getFilterOptions = () => {
    const categories = {};
    activeItems.forEach(item => {
      if (item.category) {
        if (!categories[item.category]) {
          categories[item.category] = new Set();
        }
        if (item.subcategory && item.subcategory !== 'Not found') {
          categories[item.category].add(item.subcategory);
        }
      }
    });

    // Convert Sets to Arrays and sort categories and subcategories alphabetically
    return Object.entries(categories)
      .map(([category, subcategories]) => ({
        category,
        subcategories: Array.from(subcategories).sort()
      }))
      .sort((a, b) => a.category.localeCompare(b.category));
  };

  const handleFilterSelect = (category, subcategory = null) => {
    setSelectedFilter({ category, subcategory });
  };

  const clearFilter = () => {
    setSelectedFilter(null);
  };

  const fieldsToSearch = ['description', 'height', 'length', 'width', 'weight', 'category', 'subcategory', 'subtitle', 'title', 'search_keywords'];
  
  // First filter active items, then apply search and category filters
  const activeItems = data.filter(item => 
    item.active === true || item.active.toLowerCase() === "true"
  );

  const preparedData = activeItems
    .filter((item) =>
      fieldsToSearch.some(prop => {
        if (prop === 'search_keywords' && Array.isArray(item[prop])) {
          // Handle search_keys as array
          return item[prop].some(key => 
            key?.toString().toLowerCase().includes(searchTerm.toLowerCase())
          );
        }
        // Handle other fields as before
        return item[prop]?.toString().toLowerCase().includes(searchTerm.toLowerCase());
      })
    )
    .filter((item) =>
      (!selectedFilter || 
        (selectedFilter.category === item.category && 
        (!selectedFilter.subcategory || selectedFilter.subcategory === item.subcategory))
      )
    )
    .sort((a, b) => 
      (a.category || '').localeCompare(b.category || '') || 
      (a.subcategory || '').localeCompare(b.subcategory || '') || 
      (a.title || '').localeCompare(b.title || '')
    );

  const addToCart = (item) => {
    setCart((prevCart) => {
      const itemExists = prevCart.find(
        (cartItem) => cartItem.store_items_id === item.store_items_id
      );
      if (itemExists) {
        return prevCart.map((cartItem) =>
          cartItem.store_items_id === item.store_items_id
            ? {
                ...cartItem,
                quantity: cartItem.quantity + 1,
                lead_time_hours: (cartItem.quantity + 1) > item.quantity
                  ? item.lead_time_hours + (24 * 7) // base + 1 week
                  : item.lead_time_hours
              }
            : cartItem
        );
      }
      return [...prevCart, { ...item, quantity: 1 }];
    });
    setIsCartModalOpen(true);
  };

  const updateCartQuantity = (id, quantity) => {
    const inventoryItem = data.find(item => item.store_items_id === id);
    const currentCartItem = cart.find(item => item.store_items_id === id);
    
    // Show modal only when crossing threshold upward
    if (currentCartItem?.quantity <= inventoryItem.quantity && 
        quantity > inventoryItem.quantity) {
      setLimitedItem(inventoryItem);
      setShowQuantityLimitModal(true);
    }

    setCart((prevCart) =>
      prevCart.map((item) =>
        item.store_items_id === id
          ? {
              ...item,
              quantity: quantity,
              lead_time_hours: Number(inventoryItem.lead_time_hours) + (
                quantity > inventoryItem.quantity ? (24 * 7) : 0
              )
            }
          : item
      )
    );
  };

  const handleRemoveFromCart = (id) => {
    setCart((prevCart) =>
      prevCart.filter((item) => item.store_items_id !== id)
    );
  };

  const getCartItemQuantity = (id) => {
    const item = cart.find((cartItem) => cartItem.store_items_id === id);
    return item ? item.quantity : 0;
  };

  const styles = {
    quantityButton: {
      minWidth: '15px',
      height: '32px',
      padding: 0,
      fontSize: '18px',
      backgroundColor: theme.accentColor,
      color: 'white',
      borderRadius: '4px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    input: {
      width: '50px',
      padding: '5px',
      backgroundColor: theme.backgroundColor,
      color: 'black',
      border: `1px solid ${theme.accentColor}`,
      borderRadius: '5px',
      fontSize: 12,
      textAlign: 'center',
      margin: '0 1px',
    },
    th: {
      backgroundColor: theme.backgroundColor,
      color: getComplementaryColor(theme.backgroundColor),
      padding: "10px",
      textAlign: "left",
      whiteSpace: "nowrap",
      position: "sticky",
      top: 0,
      zIndex: 2,
      fontSize: 14,
      fontWeight: "400",
    },
    td: {
      padding: "10px",
      textAlign: "left",
      borderBottom: `1px solid ${theme.primaryFontColor}`, // Update border color
      fontSize: 13,
      color: getComplementaryColor(theme.backgroundColor),
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "200px",
    },
    title: {
      maxWidth: "75px"
    },


    "@media (max-width: 768px)": {
      td: {
        maxWidth: "300px",
      },
    },
  };

  return (
    <div className="dashboard">
      <div className="header-container">
        <div className="header">
            {storeData?.logo_url ? (
              <img 
                src={
                  storeData.store_id === "9q46q14j66856-4791wn2w826094n70-4n"
                  ? kuwaharaLogo
                  : storeData.store_id === "1307937qb11b90-0331377309u0055i3-475"
                  ? metalmartLogo
                  : storeData.store_id === "1a113r930ra794-4368900x7x189xx6-9s4"
                  ? darkHorseTimberLogo
                  : storeData.store_id === "15143l4l59z259-5881731k67981kk0k-k65"
                  ? northshorewoodslogo
                  : storeData.store_id === "13031u01h4411h-3051151c52c68419c-cc5"
                  ? blancohardwoodlogo
                  : storeData.store_id === "155m6e63m6123m-861dd71g1012g843-g18"
                  ? boardsandbeamslogo
                  : storeData.store_id === "173338z5310858-65z12110814561q58-828"
                  ? cartercustomlogo
                  : storeData.store_id === "n062978y8970n4-7y81208282668l8l7-107"
                  ? slabandsteellogo
                  : storeData.store_id === "148342q0827dq1-12915769426796959-76"
                  ? supplyreadylogo
                  : storeData.store_id === "1737217s72s201-193p0449p23806w07-3p2"
                  ? cindyswoodlotlogo
                  : storeData.store_id === "m4q7860q34q324-258103789y0l93174-yy9"
                  ? nicholasfirewoodlogo
                  : storeData.store_id === "1131ru33u76u73-3714383n35c77424-0c4"
                  ? woodfloorwarehouselogo
                  : storeData.logo_url
                }
                alt="Store Logo"
                className="store-logo"
              />
            ) : null}

            <div className="header-info">
              <p className="store-name">
                {storeData?.display_name}
              </p>
              <p className="store-address">
                {storeData?.address} {storeData?.city}, {storeData?.state}{" "}
                <br />
                <a href={`tel:${storeData?.display_phone}`} style={{ color: theme.headerFontColor }}>
                  <span>{storeData?.display_phone ? formatPhoneNumber(storeData.display_phone) : ''}</span>
                </a>
              </p>
            </div>
        </div>
        <div className="search-and-cart">
          {/* Search bar and action buttons */}
          <div className="search-cart-container">
            <div className="search-bar-container">
              <input
                type="text"
                placeholder="Search inventory..."
                value={searchTerm}
                onChange={handleSearch}
                className="search-input"
              />
            </div>
            <div className="header-buttons-container">
              {getFilterOptions().length > 0 ? (
                <FilterMenu
                  filterOptions={getFilterOptions()}
                  selectedFilter={selectedFilter}
                  onFilterSelect={handleFilterSelect}
                  onClearFilter={clearFilter}
                />
              ) : (
                <div/>
              )}
              
              <button
                className="header-button cart-button"
                onClick={() => setIsCartModalOpen(true)}
              >
                <span className="button-text">View Cart ({cart.length})</span>
                <span className="button-icon">
                  <img src={cartIcon} alt="Cart" />
                  {cart.length > 0 && (
                    <span className="cart-badge">
                      {cart.length}
                    </span>
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="ecomm-table-container">
        <table style={styles.table}>
          <thead
            style={{
              position: "sticky",
              top: 0,
              zIndex: 2,
              boxShadow: `0px 1.5px 0px ${theme.primaryFontColor}`,
            }}
          >
            <tr>
              <th style={styles.th} className="col-actions">Actions</th>
              <th style={styles.th} className="col-title">Title</th>
              <th style={styles.th} className="col-description">Description</th>
              <th style={styles.th} className="col-sku">SKU</th>
              <th style={styles.th} className="col-leadtime">Lead Time</th>
              <th style={styles.th} className="col-num-in-stock">Available Inventory</th>
              <th style={{ ...styles.th, textAlign: "right" }} className="col-price">Unit Price</th>
            </tr>
          </thead>
          <tbody>
            {preparedData.map((row, rowIndex) => (
              <tr 
                key={rowIndex}
                onClick={(e) => {
                  // Only show modal if not clicking the Add to Cart button or quantity input
                  if (!e.target.closest('.table-action-button') && !e.target.closest('.quantity-input')) {
                    setSelectedItem(row);
                  }
                }}
                style={{ cursor: 'default' }}
              >
                <td style={styles.td} className="col-actions">
                  {getCartItemQuantity(row.store_items_id) > 0 ? (
                      <QuantityInput
                        value={getCartItemQuantity(row.store_items_id)}
                        onBlur={(numVal) => {
                          updateCartQuantity(row.store_items_id, numVal);
                        }}
                        onRemove={() => {
                          handleRemoveFromCart(row.store_items_id);
                        }}
                        theme={theme}
                        className="quantity-input"
                      />
                  ) : (
                    <button
                      className="table-action-button"
                      onClick={() => addToCart(row)}
                    >
                      {window.innerWidth > 600 ? 'Add to Cart' : 'Add'}
                    </button>
                  )}
                </td>
                <td style={{...styles.td, ...styles.title}} className="col-title">{row.title || "-"}</td>

                {/* <td style={styles.td}>{row.subtitle || "-"}</td> */}
                <td style={styles.td} className="col-description">{row.description || "-"}</td>
                <td style={styles.td} className="col-sku">{row.sku || "-"}</td>
                <td style={styles.td} className="col-leadtime">{formatLeadTime(row.lead_time_hours)}</td>
                <td style={styles.td} className="col-num-in-stock">{row.quantity || "-"}</td>
                <td style={{ ...styles.td, textAlign: "right" }} className="col-price">
                  {row.price_type.toLowerCase() === "variable" ? (
                    "Variable"
                  ) : (
                    <>
                      ${row.retail_price
                        ? Number(row.retail_price.replace(/,/g, "")).toFixed(2)
                        : "-"}
                    </>
                  )}
                </td>
                {/* <td style={styles.td}>
                  $
                  {row.wholesale_price
                    ?  Number(row.wholesale_price.replace(/,/g, "")).toFixed(2)
                    : "-"}
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {isCartModalOpen && (
        <CartModal
          cart={cart}
          setCart={setCart}
          onUpdateQuantity={updateCartQuantity}
          onRemoveItem={handleRemoveFromCart}
          onCloseModal={() => setIsCartModalOpen(false)}
          store={storeData}
          storeSchedule={storeSchedule}
          theme={theme}
          refreshInventory={fetchInventory}
          total={total} // Pass total to CartModal
          setTotal={setTotal} // Allow CartModal to update total
          shippingMethod={shippingMethod}
          setShippingMethod={setShippingMethod}
          deliveryOption={deliveryOption}
          setDeliveryOption={setDeliveryOption}
          deliveryFee={deliveryFee}
          setDeliveryFee={setDeliveryFee}
          tax={tax}
          setTax={setTax}
          deliveryDate={deliveryDate}
          setDeliveryDate={setDeliveryDate}
          deliveryTime={deliveryTime}
          setDeliveryTime={setDeliveryTime}
          pickupDate={pickupDate}
          setPickupDate={setPickupDate}
          pickupTime={pickupTime}
          setPickupTime={setPickupTime}
          deliveryAddress={deliveryAddress}
          setDeliveryAddress={setDeliveryAddress}
          deliveryCity={deliveryCity}
          setDeliveryCity={setDeliveryCity}
          deliveryState={deliveryState}
          setDeliveryState={setDeliveryState}
          deliveryZip={deliveryZip}
          setDeliveryZip={setDeliveryZip}
          contactFirstName={contactFirstName}
          setContactFirstName={setContactFirstName}
          contactLastName={contactLastName}
          setContactLastName={setContactLastName}
          contactBusinessName={contactBusinessName}
          setContactBusinessName={setContactBusinessName}
          contactEmail={contactEmail}
          setContactEmail={setContactEmail}
          contactPhone={contactPhone}
          setContactPhone={setContactPhone}
          billingFirstName={billingFirstName}
          setBillingFirstName={setBillingFirstName}
          billingLastName={billingLastName}
          setBillingLastName={setBillingLastName}
          billingEmail={billingEmail}
          setBillingEmail={setBillingEmail}
          billingAddress={billingAddress}
          setBillingAddress={setBillingAddress}
          billingPhone={billingPhone}
          setBillingPhone={setBillingPhone}
          billingCity={billingCity}
          setBillingCity={setBillingCity}
          billingState={billingState}
          setBillingState={setBillingState}
          billingZip={billingZip}
          setBillingZip={setBillingZip}
          deliveryOptions={deliveryOptions}
          setDeliveryOptions={setDeliveryOptions}
          totalDriveTime={totalDriveTime}
          setTotalDriveTime={setTotalDriveTime}
          optionsReceived={optionsReceived}
          setOptionsReceived={setOptionsReceived}
          formattedDeliveryAddress={formattedDeliveryAddress}
          setFormattedDeliveryAddress={setFormattedDeliveryAddress}
          routeDetails={routeDetails}
          setRouteDetails={setRouteDetails}
          discount={discount}
          setDiscount={setDiscount}
          discountCode={discountCode}
          setDiscountCode={setDiscountCode}
          discountRate={discountRate}
          setDiscountRate={setDiscountRate}
          discountCodeId={discountCodeId}
          setDiscountCodeId={setDiscountCodeId}
          confirmationCode={confirmationCode}
          setConfirmationCode={setConfirmationCode}
          orderId={orderId}
          setOrderId={setOrderId}
          availableDateOptions={availableDateOptions}
          setAvailableDateOptions={setAvailableDateOptions}
        />
      )}
      <QuantityLimitModal />
      <ItemModal
        show={selectedItem !== null}
        onClose={() => setSelectedItem(null)}
        item={selectedItem}
        theme={theme}
        onAddToCart={() => {
          addToCart(selectedItem);
          setSelectedItem(null);
        }}
        onViewCart={() => {
          setIsCartModalOpen(true);
          setSelectedItem(null);
        }}
        getCartItemQuantity={getCartItemQuantity}
        updateCartQuantity={updateCartQuantity}
        handleRemoveFromCart={handleRemoveFromCart}
      />
    </div>
  );
}

export default Ecomm;

